<div class="common-modal__container">
  <!-- Cabecera -->
  <div class="common-modal__header">
    <span class="common-modal__text-header">{{shareDocument.title}}</span>
  </div>
  <!-- Contenedor -->
  @if (configuration.type === 'shareFieldContainer') {
    <wizard-steps
      [steps]="shareDocument.steps"
      [state]="shareDocument.wizardState">
    </wizard-steps>
  }
  <div class="common-modal__content">
    @if (shareDocument.infoShare) {
      <p class="common-modal__content-header-info">{{shareDocument.infoShare}}</p>
    }
    @if(shareDocument.showInformationBand){
      <div class="common-status-message__g-container-info">
        <i class="lf-icon-info-full common-status-message__icon-md"></i>
        <div class="common-status-message__g-content">
            <div class="common-status-message__g-icon-text-content">
              <div class="common-status-message__g-title-subtitle">
                <span class="common-status-message__g-subtitle"
                  [afTranslate]="'share-document.info-contacts-sms'"></span>
              </div>
              <button class="common-button__icon-xs-noborder"
                (click)="shareDocument.showInformationBand = false">
                <i class="lf-icon-close-thick common-icon__sm"></i>
              </button>
            </div>
        </div>
      </div>
    }
    <div class="common-modal__form-container">
      @if (shareDocument.isReportFinished){
        <div class="common-container__mandatory-obligatory-message-form">
          <span class="common-tag__mandatory-text-asterisk">*</span>
          <span class="common-tag__mandatory-label-text-obligatory-message"
            [afTranslate]="'common.required-fields'">_Campos obligatorios</span>
        </div>
      }
      @switch (shareDocument.wizardState) {
        @case (2) {
          <field-type-list-extended [field]="shareDocument.shareTypeDocumentField"
            [listValues]="shareDocument.typeShareDocument"
            [preSelectItem]="shareDocument.typeShareDocumentSelected"
            (itemSelected)="shareDocument.typeShareDocumentSelected = $event.newValue">
          </field-type-list-extended>
          @if (shareDocument.typeShareDocumentSelected === 2) {
            <field-type-list-multiple
              [field]="shareDocument.shareDocumentationField"
              [listValues]="shareDocument.shareDocumentationList"
              [preSelectItem]="shareDocument.shareDocumentationListSelected"
              (itemSelected)="selectSharedDocumentation($event)">
            </field-type-list-multiple>
          }
        }
        @default {
          @if (shareDocument.isReportFinished && shareDocument.sharedContacts) {
            <field-type-contacts
              [field]="shareDocument.sharedContacts"
              [concept]="configuration.concept"
              [valueId]="shareDocument.valueId"
              (sendContacts)="receiveContacts($event)">
            </field-type-contacts>
          }
          @if (!shareDocument.signatureCertificate) {
            <field-type-rich-text-editable
              [field]="shareDocument.commentField"
              [preSelectItem]="shareDocument.message"
              (itemSelected)="getEditorValue($event)">
            </field-type-rich-text-editable>
          }
          @if (shareDocument.showAnswerSurvey) {
            <field-type-switch [field]="shareDocument.answerSurveyField"
              [small]="true"
              [preSelectItem]="shareDocument.answerSurvey"
              [disabled]="configuration.type === 'send-sms-certificate' && !shareDocument.phoneNumberSMS"
              (itemSelected)="changeSurvey($event.newValue)">
            </field-type-switch>
          }
          <!-- @if (shareDocument.showInfoError) {
            <div class="share-document__block-info-message">
              <i class="lf-icon-warning share-document__icon-alert"></i>
              <p class="share-document__text-alert"
                [afTranslate]="'share-document.info-error-sms'"></p>
              <i class="lf-icon-close field-type-contacts__icon-close-header"
                (click)="shareDocument.showInfoError = !shareDocument.showInfoError"></i>
            </div>
          } -->
        }
      }
    </div>
  </div>
  <!-- Footer botonera -->
  @if (configuration.type === 'shareFieldContainer') {
    <div class="common-modal__footer">
      <button [ngClass]="shareDocument.wizardState === 2?'common-button__text-noborder':'common-button__text-border'"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      @switch (shareDocument.wizardState) {
        @case (1) {
          <button class="common-button__text"
            (click)="nextStep()">
            <span class="common-button__text-title"
              [afTranslate]="'common.next'"></span>
          </button>
        }
        @case (2) {
          <button class="common-button__text-border"
            (click)="backStep()">
            <span class="common-button__text-title"
              [afTranslate]="'common.previous'"></span>
          </button>
          <button class="common-button__text"
            (click)="handleAccept()">
            <span class="common-button__text-title">{{shareDocument.buttonSend}}</span>
          </button>
        }
      }
    </div>
  }@else {
    <div class="common-modal__footer">
      <button class="common-button__text-border"
        (click)="handleDismiss()">
        <span class="common-button__text-title"
          [afTranslate]="'common.cancel'">_Cancelar</span>
      </button>
      <button class="common-button__text"
        (click)="sendShare()">
        <span class="common-button__text-title">{{shareDocument.buttonSend}}</span>
      </button>
    </div>
  }
</div>
